import axios from './index'

export default {
  getForms() {
    return axios.get('/api/auth/forms')
  },
  sendForm(data) {
    return axios.post('/api/auth/forms', data, {
      responseType: 'blob'
    })
  },
  /** zgody z medapi: link SMS/e-mail do potwierdzenia przez pacjenta */
  sendLink(data) {
    return axios.post('/api/auth/forms/send-link', data)
  }
}
